<div>
  @switch (field.inputType) {
    @case ('standard') {
      <div style="padding-left: 45px">
        @if (hideMe!=true) {
          <span fxLayout="column" fxLayoutAlign="start start" class="{{field.name}}-dynamic-class demo-full-width" [formGroup]="group">
            <a mat-raised-button (click)="callBackAction($event)">
              <mat-icon>{{field.icon}}</mat-icon>
              {{field.value}}
            </a>
            <br/>
          </span>
        }
      </div>
    }
    @default {
      <div>
        @if (hideMe!=true) {
          <span class="{{field.name}}-dynamic-class">
            <span class="{{field.name}}-dynamic-class">
              <div class="demo-full-width margin-top" [formGroup]="group">
                <button type="submit" mat-raised-button color="primary">{{field.label}}</button>
              </div>
            </span>
          </span>
        }
      </div>
    }
  }
</div>
